import { Navigate, Outlet, Route } from "react-router-dom";

import { App } from "@/App";
import { AgentLogin } from "@/components/AgentLogin.tsx";
import { MagicLogin } from "@/components/MagicLogin";
import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner";
import { authenticatorRouteComponents } from "@/router/AuthenticatorRoutes";
import { LoginRedirect } from "@/router/LoginRedirect";
import { onboardingRoutes as onboardingRouteComponents } from "@/router/OnboardingRoutes";
import { portalRouter as portalRouteComponents } from "@/router/PortalRoutes";
import { ProtectedRoute } from "@/router/ProtectedRoute";
import redirects from "@/router/redirects";
import { PORTAL_BASE_ROUTE } from "@/router/routes/portalRoutes";
import { WelcomeFriendsWithBenefits } from "@/views/FriendsWithBenefits/WelcomeFriendsWithBenefits";
import { NotFound } from "@/views/NotFound/NotFound";
import { Onboarding } from "@/views/Onboarding/Onboarding";
import { Portal } from "@/views/Portal/Portal";
import { TestWebshop } from "@/views/TestWebshop/TestWebshop";
import { Welcome } from "@/views/Welcome";
import { WelcomeEsim } from "@/views/WelcomeEsim";
import { WelcomeScreen } from "@/views/WelcomeScreen/WelcomeScreen";

const redirectRoutes = redirects.map((redirect) => (
  <Route
    key={redirect.from}
    path={redirect.from}
    element={<Navigate to={redirect.to} replace />}
  />
));

export const customerRoutes = [
  <Route
    key="baseRoute"
    path="/"
    element={
      <ProtectedRoute user="customer">
        <App />
      </ProtectedRoute>
    }
  >
    <Route index element={<Navigate to="/welcome" replace />} />
    <Route path="onboarding/*" element={<Onboarding />}>
      {onboardingRouteComponents}
    </Route>
    <Route path={PORTAL_BASE_ROUTE} element={<Portal />}>
      {portalRouteComponents}
    </Route>
  </Route>,
  ...authenticatorRouteComponents,
  <Route
    key="404-catchall"
    path="*"
    element={<Navigate to="/404" replace />}
  />,
  <Route key="404" path="/404" element={<NotFound />} />,
  <Route key="agentlogin" path="/agentLogin" element={<AgentLogin />} />,
  <Route key="test-webshop" path="/test-webshop" element={<TestWebshop />} />,
  <Route
    key="magiclogin"
    path="/portal/cockpit/magiclogin"
    element={<MagicLogin />}
  />,
  <Route
    key="welcome-base"
    element={
      <LoginRedirect>
        <Outlet />
      </LoginRedirect>
    }
  >
    <Route index key="welcome" path="/welcome" element={<WelcomeScreen />} />
    <Route
      key="alternative-welcome"
      path="/alternative-welcome"
      element={<Welcome />}
    />
    <Route key="welcome-esim" path="/welcome-esim" element={<WelcomeEsim />} />
    <Route
      key="welcome-loading-spinner"
      path="/welcome/loading"
      element={<WelcomeLoadingSpinner />}
    />
  </Route>,
  <Route
    key="welcome-friends-with-benefits"
    path="/:tribeId/:tribe2CustomerId"
    element={<WelcomeFriendsWithBenefits />}
  />,
  ...redirectRoutes,
];
